/* eslint-disable */
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { TextField } from "@material-ui/core";
import IRecipientDetailsProps from "./Recipient";
import { DropdownIcon } from "../../../../assets/Icons";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles(() => ({
  label: {
    marginLeft: "12px",
    paddingBottom: "4px",
  },
}));

export const StepTwo: FunctionComponent<IRecipientDetailsProps.StepTwoProps> = ({
  category,
  residenceCountry,
  setIsModalOpen,
  city,
  setCity,
  pin,
  setPin,
  address1,
  setAddress1,
  address2,
  setAddress2,
  setResidenceCountry,
  countryList,
}) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = React.useState("");
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  return (
    <div className="flex flex-col items-center space-y-10 justify-content">
      <div id="line1" className="flex space-x-20">
        <div
          id="relationship"
          onClick={() => setIsModalOpen("category")}
          className="h-[58px] w-[400px] bg-white border flex items-center border-gray-400 rounded-md p-4 text-[14px] justify-between cursor-pointer recepient-category"
        >
          <div>{category ? `${category}` : "Category*"}</div>
          <div>
            <DropdownIcon />
          </div>
        </div>
        <div id="DTInput" className="">
          <div className="flex flex-col">
            <div>
              <Autocomplete
                value={residenceCountry}
                onChange={(event: any, newValue: string | null) => {
                  setResidenceCountry(newValue);
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                }}
                id="controllable-states-demo"
                options={countryList}
                style={{ width: 400 }}
                renderInput={(params) => (
                  <TextField required {...params} label="Country of Residence" variant="outlined" />
                )}
              />
            </div>
          </div>
        </div>
      </div>
      <div id="line2" className="flex space-x-20">
        <TextField
          className="w-[400px]"
          name="City"
          label="City"
          variant="outlined"
          required={true}
          onChange={(e) => setCity(e.target.value)}
          value={city}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
        <TextField
          className="w-[400px]"
          name="pincode"
          label="PIN Code"
          variant="outlined"
          required={true}
          onChange={(e) => setPin(e.target.value)}
          value={pin}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
      </div>
      <div id="line3" className="flex space-x-20">
        <TextField
          className="w-[400px]"
          name="address1"
          variant="outlined"
          label="Address Line 1"
          required={true}
          onChange={(e) => setAddress1(e.target.value)}
          value={address1}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
        <TextField
          className="w-[400px]"
          name="address2"
          variant="outlined"
          label="Address Line 2"
          onChange={(e) => setAddress2(e.target.value)}
          value={address2}
          inputProps={{ pattern: { specialCharRegExp } }}
        />
      </div>
    </div>
  );
};
